import * as serviceWorker from './serviceWorker';
import React from 'react'
import { render } from 'react-dom'
import Application from './containers/Application'
import { Provider } from 'react-redux'
import { applyMiddleware, createStore } from 'redux'
import RootReducer from './reducers/RootReducer'
import { createLogger } from 'redux-logger'
import thunk from 'redux-thunk'
import Keycloak from 'keycloak-js'
import { BrowserRouter, Route } from 'react-router-dom'
import config from './config'
import './less/styles.less'
import { UPDATE_TOKEN, UPDATE_ID_TOKEN } from './Constants';

const kc = new Keycloak(config.keycloak)

const initialState = {}

let store

if (process.env.NODE_ENV) {
  store = createStore(
    RootReducer,
    initialState,
    applyMiddleware(thunk)
  )
} else {
  store = createStore(
    RootReducer,
    initialState,
    applyMiddleware(thunk, createLogger())
  )
}

kc.init({
  onLoad: 'check-sso',
  pkceMethod: 'S256',
  checkLoginIframe: false
}).success(authenticated => {
  if (authenticated) {

    if (window.location.hash && window.location.hash.includes('iss=')) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    };

    store.dispatch({
      token: kc.token,
      type: UPDATE_TOKEN
    });
    store.dispatch({
      token: kc.idToken,
      type: UPDATE_ID_TOKEN,
    });

    setInterval(() => {
      kc.updateToken(10)
        .success((isUpdated) => {
          if (isUpdated) {
            store.dispatch({
              token: kc.token,
              type: UPDATE_TOKEN
            })

            store.dispatch({
              token: kc.idToken,
              type: UPDATE_ID_TOKEN,
            });
          }
        }).error((e) => {
          console.log("Error:", e);
          // kc.logout();
        })
    }, 10000)

    try {
      render(
        <Provider store={store}>
          <BrowserRouter>
            <Route component={Application} />
          </BrowserRouter>
        </Provider>,
        document.getElementById('root')
      )
    } catch (e) {
      const RedBox = require('redbox-react').default
      render(
        <RedBox error={e} />,
        document.getElementById('root')
      )
    }

  } else {

    store.dispatch({
      type: 'CLEAR'
    })

    kc.login()
  }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
